// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__CqTJx","description":"PatientConsentPreview_description__3m36N"};